import React from 'react';
import { Link } from 'react-router-dom';

interface BreadcrumbsProps {
  paths?: { label: string; url: string }[];
  hideLastOnMobile?: boolean;
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ paths = [], hideLastOnMobile }) => {
  if (paths.length === 0) return null;

  return (
    <ol className="breadcrumb" aria-label="breadcrumbs">
      {paths.map((path, index) => (
        <li
          key={index}
          className={`breadcrumb-item ${index === paths.length - 1 ? 'active' : ''} ${hideLastOnMobile && index === paths.length - 1 ? 'd-none d-lg-inline' : ''}`}
        >
          {path.url && index < paths.length - 1 ? (
            <Link to={path.url} className="breadcrumb-link">
              {path.label}
            </Link>
          ) : (
            <span>{path.label}</span>
          )}
        </li>
      ))}
    </ol>
  );
};

export default Breadcrumbs;
